import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {isPresent} from '../utils/lang';

@Injectable()
export class GPTranslateService extends TranslateService {
  public instant(key: string | Array<string>, interpolateParams?: Object): string | any {
    return super.instant(isPresent(key) && key !== '' ? (key + '') : ' ', interpolateParams);
  }

  /***
   * Return translated transId separated by a slash (limit to 4)
   * @param transIds
   * @param separator
   */
  public getDisplayTranslation(transIds?: string[], separator = ' / ' ): string {
    const uniqTranslate = new Set((transIds || []).map(transId => super.instant(transId)));
    const array = Array.from(uniqTranslate).slice(0, 4);
    return array.join(separator);
  }

  /***
   * Return the first unique translated text from the given transIds.
   * @param transIds - array of translation keys
   */
  public getFirstTranslation(transIds?: string[]): string {
    const uniqTranslate = Array.from(new Set((transIds || []).map(transId => super.instant(transId))));
    return uniqTranslate.length > 0 ? uniqTranslate[0] : '';
  }
}
